import { SeasonRecordPayoutStateEnum } from './season-record-payout-state.enum';

export class SeasonRecordsUiMappingHelper {
  private static readonly maps = {
    [SeasonRecordPayoutStateEnum.FullPayout]: '100% Payout'
  };

  public static mapValue(value: string): string {
    return this.maps[value] ?? value;
  }
}
